import { render, staticRenderFns } from "./SupplierProductSelecteCategoryAndProduct.vue?vue&type=template&id=4b3956a6"
import script from "./SupplierProductSelecteCategoryAndProduct.vue?vue&type=script&lang=js"
export * from "./SupplierProductSelecteCategoryAndProduct.vue?vue&type=script&lang=js"
import style0 from "./SupplierProductSelecteCategoryAndProduct.vue?vue&type=style&index=0&id=4b3956a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports